import { toBase64 } from "@insightfulscience/shared-utils/fn/to-base-64";

export const generateHeadingId = children => {
	return toBase64(encodeURI(children.toString().trim())).replace(/=/g, "");
};

export const sidebarNavigation = body =>
	body?.content.filter(node => node.nodeType === "heading-2").map(item => item.content[0].value);
